import React from 'react';
import { MailIcon, PhoneIcon, MapPinIcon, ClockIcon, SendIcon } from 'lucide-react';
export function ContactPage() {
  return <div className="pt-20" data-id="element-252">
      <section className="bg-brand-navy py-24 text-white" data-id="element-253">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-254">
          <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-255">
            Book a Consultation
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-256">
            Take the first step towards restoring your health and renewing your
            mind.
          </p>
        </div>
      </section>

      <section className="py-24 bg-white" data-id="element-257">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-258">
          <div className="grid lg:grid-cols-2 gap-16" data-id="element-259">
            {/* Contact Form */}
            <div className="bg-brand-light p-8 md:p-12 rounded-3xl border border-gray-100 shadow-sm" data-id="element-260">
              <h2 className="text-2xl font-bold text-brand-navy mb-8" data-id="element-261">
                Send us a Message
              </h2>
              <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-262">
                <div className="grid md:grid-cols-2 gap-6" data-id="element-263">
                  <div data-id="element-264">
                    <label className="block text-sm font-bold text-brand-navy mb-2" data-id="element-265">
                      First Name
                    </label>
                    <input type="text" className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-brand-red outline-none transition-all" placeholder="John" data-id="element-266" />
                  </div>
                  <div data-id="element-267">
                    <label className="block text-sm font-bold text-brand-navy mb-2" data-id="element-268">
                      Last Name
                    </label>
                    <input type="text" className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-brand-red outline-none transition-all" placeholder="Doe" data-id="element-269" />
                  </div>
                </div>
                <div data-id="element-270">
                  <label className="block text-sm font-bold text-brand-navy mb-2" data-id="element-271">
                    Email Address
                  </label>
                  <input type="email" className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-brand-red outline-none transition-all" placeholder="john@example.com" data-id="element-272" />
                </div>
                <div data-id="element-273">
                  <label className="block text-sm font-bold text-brand-navy mb-2" data-id="element-274">
                    Service of Interest
                  </label>
                  <select className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-brand-red outline-none transition-all" data-id="element-275">
                    <option data-id="element-276">Family Practice & Wellness</option>
                    <option data-id="element-277">Mental Health Coaching</option>
                    <option data-id="element-278">Marriage & Family Coaching</option>
                    <option data-id="element-279">Trauma & PTSD Support</option>
                    <option data-id="element-280">Professional Consultation</option>
                  </select>
                </div>
                <div data-id="element-281">
                  <label className="block text-sm font-bold text-brand-navy mb-2" data-id="element-282">
                    Message
                  </label>
                  <textarea rows={4} className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-brand-red outline-none transition-all" placeholder="How can we help you?" data-id="element-283"></textarea>
                </div>
                <button className="w-full bg-brand-navy text-white py-4 rounded-xl font-bold text-lg hover:bg-brand-red transition-all shadow-lg flex items-center justify-center" data-id="element-284">
                  Request Consultation
                  <SendIcon className="ml-2 h-5 w-5" data-id="element-285" />
                </button>
              </form>
            </div>

            {/* Contact Info */}
            <div className="lg:py-8" data-id="element-286">
              <h2 className="text-2xl font-bold text-brand-navy mb-8" data-id="element-287">
                Contact Information
              </h2>
              <div className="space-y-8" data-id="element-288">
                <div className="flex items-start space-x-4" data-id="element-289">
                  <div className="bg-brand-red/10 p-4 rounded-2xl" data-id="element-290">
                    <PhoneIcon className="h-6 w-6 text-brand-red" data-id="element-291" />
                  </div>
                  <div data-id="element-292">
                    <h3 className="font-bold text-brand-navy" data-id="element-293">Phone</h3>
                    <p className="text-gray-600" data-id="element-294">Contact us for scheduling</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4" data-id="element-295">
                  <div className="bg-brand-red/10 p-4 rounded-2xl" data-id="element-296">
                    <MailIcon className="h-6 w-6 text-brand-red" data-id="element-297" />
                  </div>
                  <div data-id="element-298">
                    <h3 className="font-bold text-brand-navy" data-id="element-299">Email</h3>
                    <p className="text-gray-600" data-id="element-300">info@globalrestorative.com</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4" data-id="element-301">
                  <div className="bg-brand-red/10 p-4 rounded-2xl" data-id="element-302">
                    <MapPinIcon className="h-6 w-6 text-brand-red" data-id="element-303" />
                  </div>
                  <div data-id="element-304">
                    <h3 className="font-bold text-brand-navy" data-id="element-305">Location</h3>
                    <p className="text-gray-600" data-id="element-306">
                      Serving Locally, Nationally, and Globally
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-4" data-id="element-307">
                  <div className="bg-brand-red/10 p-4 rounded-2xl" data-id="element-308">
                    <ClockIcon className="h-6 w-6 text-brand-red" data-id="element-309" />
                  </div>
                  <div data-id="element-310">
                    <h3 className="font-bold text-brand-navy" data-id="element-311">Hours</h3>
                    <p className="text-gray-600" data-id="element-312">
                      Monday - Friday: 9:00 AM - 5:00 PM
                    </p>
                    <p className="text-gray-600" data-id="element-313">Weekend: By Appointment</p>
                  </div>
                </div>
              </div>

              <div className="mt-12 p-8 bg-brand-navy rounded-3xl text-white" data-id="element-314">
                <h3 className="text-xl font-bold mb-4" data-id="element-315">Urgent Care?</h3>
                <p className="text-gray-300 mb-0" data-id="element-316">
                  If you are experiencing a medical or mental health emergency,
                  please call 911 or visit your nearest emergency room
                  immediately.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
}